import React from "react";
import EventCalendar from "../../assets/svgcomps/EventCalendarComp";
import { CONSTANTS } from "../../constants/Constants";
import moment from "moment";

interface AvailablityStatusProps {
  availability: string;
  availableFrom?: string;
}

const AvailablityStatus: React.FC<AvailablityStatusProps> = ({
  availability,
  availableFrom,
}) => {
  return (
    <div
      className={`w-fit font-medium flex md:items-center text-[13px] rounded ${
        availability === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
          ? "text-primary-dark"
          : availability === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
          ? "#00000"
          : " text-orange"
      }`}
    >
      <EventCalendar
        fill={
          availability === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
            ? CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR
            : availability === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
            ? CONSTANTS.APP_DEFAULT_COLORS.BLACK_COLOR
            : CONSTANTS.APP_DEFAULT_COLORS.ORANGE_COLOR
        }
      />
      <p className="ms-1 me-1">
        {availability === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
          ? CONSTANTS.AVAILABILITY_IMMEDIATELY_TXT
          : availability === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
          ? CONSTANTS.AVAILABLE_ON_DATE_TXT
          : CONSTANTS.NOT_AVAILABLE_TXT}
        <br className="md:hidden" />
        {availableFrom && (
          <small className="ms-1 text-center">
            {moment(availableFrom).format("DD MMM YY")}
          </small>
        )}
      </p>
    </div>
  );
};

export default AvailablityStatus;
